import { useMemo } from 'react';
import { sectionLeadTimesSelector } from '@lingoda/booking';
import { useIntervalDate, useSelector } from '@lingoda/hooks';
import { ClassType } from '@lingoda/monolith-graphql';
import { type LeadTime, resolveLeadTime } from './resolveLeadTime';

// One authority for the lead time, so the banner's decision and its text can never disagree
// about it. `now` is the start of the current hour. The app clock updates it when each hour
// starts, midnight included, or on its first tick after waking if the computer was asleep then.
// So a tab left open overnight moves to the new day on its own.
export const useLeadTime = (): LeadTime | undefined => {
    const leadTimes = useSelector(sectionLeadTimesSelector);
    // An ISO duration as the backend sends it, e.g. P7D.
    const groupLeadTime = leadTimes?.[ClassType.Group];
    const now = useIntervalDate('hour', { round: true });

    return useMemo(() => resolveLeadTime(now, groupLeadTime), [now, groupLeadTime]);
};
